// Nick Bundle Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "Calvin", location: "GA", product: "The Nick Urankar Bundle", time: "20 minutes ago" },
    { name: "John", location: "SC", product: "The Nick Urankar Bundle", time: "48 minutes ago" },
    { name: "Stephen", location: "TX", product: "The Nick Urankar Bundle", time: "1 hour 17 minutes ago" },
    { name: "Eleazar", location: "CA", product: "The Nick Urankar Bundle", time: "1 hour 47 minutes ago" },
    { name: "Aurelio", location: "CA", product: "The Nick Urankar Bundle", time: "2 hours 18 minutes ago" },
    { name: "Robert", location: "TX", product: "The Nick Urankar Bundle", time: "2 hours 50 minutes ago" },
    { name: "Jamie", location: "TX", product: "The Nick Urankar Bundle", time: "3 hours 23 minutes ago" },
    { name: "Jacob", location: "CA", product: "The Nick Urankar Bundle", time: "3 hours 57 minutes ago" },
    { name: "Brian", location: "MN", product: "The Nick Urankar Bundle", time: "4 hours 32 minutes ago" },
    { name: "Dustin", location: "TN", product: "The Nick Urankar Bundle", time: "5 hours 8 minutes ago" },
    { name: "Eleazar", location: "CA", product: "The Nick Urankar Bundle", time: "22 minutes ago" },
    { name: "William", location: "OH", product: "The Nick Urankar Bundle", time: "48 minutes ago" },
    { name: "Vontrell", location: "NV", product: "The Nick Urankar Bundle", time: "1 hour 15 minutes ago" },
    { name: "Nathaniel", location: "NY", product: "The Nick Urankar Bundle", time: "1 hour 43 minutes ago" },
    { name: "Tyler", location: "CA", product: "The Nick Urankar Bundle", time: "2 hours 12 minutes ago" },
    { name: "Natalie", location: "CA", product: "The Nick Urankar Bundle", time: "2 hours 42 minutes ago" },
    { name: "Blair", location: "MI", product: "The Nick Urankar Bundle", time: "3 hours 13 minutes ago" },
    { name: "John", location: "SC", product: "The Nick Urankar Bundle", time: "3 hours 45 minutes ago" },
    { name: "Malakhi", location: "NY", product: "The Nick Urankar Bundle", time: "4 hours 18 minutes ago" },
    { name: "Rudy", location: "CA", product: "The Nick Urankar Bundle", time: "4 hours 52 minutes ago" },
    { name: "Chris", location: "TX", product: "The Nick Urankar Bundle", time: "20 minutes ago" },
    { name: "Erik", location: "NJ", product: "The Nick Urankar Bundle", time: "47 minutes ago" },
    { name: "Fyrestar", location: "GA", product: "The Nick Urankar Bundle", time: "1 hour 14 minutes ago" },
    { name: "Anthony", location: "FL", product: "The Nick Urankar Bundle", time: "1 hour 42 minutes ago" },
    { name: "Paul", location: "IN", product: "The Nick Urankar Bundle", time: "2 hours 11 minutes ago" },
    { name: "Greg", location: "TX", product: "The Nick Urankar Bundle", time: "2 hours 41 minutes ago" },
    { name: "Mike G.", location: "CA", product: "The Nick Urankar Bundle", time: "3 hours 12 minutes ago" },
    { name: "Mike H.", location: "MN", product: "The Nick Urankar Bundle", time: "3 hours 44 minutes ago" },
    { name: "Conrad", location: "TX", product: "The Nick Urankar Bundle", time: "4 hours 17 minutes ago" },
    { name: "Candelario", location: "CA", product: "The Nick Urankar Bundle", time: "4 hours 51 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/Nick_Urankar_Bundle_No_Badge.png?v=1733786130" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
